module.exports = __webpack_public_path__ + "img/action-report.6be8afee.svg";